import React from 'react';
import * as constant from './constants';
import Button from './../Button';
import ImageButton from './../Button/ImageButton';
import UtilsProfile from '../../utils/Profile';
import { LocalTranslations, LocalAssets } from '../../requests/apa/local';
import translatesJson from './Admin.translates.json';
import assetsJson from './Admin.assets.json';
import "./admin.scss";
import Utils from '../../utils/Utils';
import logger from 'src/utils/logger/logger';

const localTranslations = new LocalTranslations(translatesJson);
const localAssets = new LocalAssets(assetsJson);

export const Admin = ({ props }) => {

  let items = props.items;
  let adminProfile = UtilsProfile.getAdminMember(items);

  //RDN Solo se agrega este boton si son menos de cuatro los elementos

  if (items && items.length && ((props.maxMembers - items.length) >= 1)) {
    let admin = UtilsProfile.getAdminMember(items);

    items.push({
      name: localTranslations.get('add_profile_label', 'Agregar Perfil'),
      imgSrc: UtilsProfile.getAddAvatar(),
      order: ['text'],
      data: admin.data,
      clickHandler: (item) => {
        if (item.data && item.data.change_name) {
          props.onSetAction(constant.COMPLETE_PROFILE, item.data);
        }
        else {
          //Se fuerza a completar perfil,
          //props.onSetAction(constant.COMPLETE_PROFILE, item.data);
          props.onSetAction(constant.ADD_PROFILE);
        }
      }
    });
  }

  UtilsProfile.setFocus('.container.admin_profile .row.avatar-option .focusable');

  return (
    <div className='container admin_profile'>
      <div className='row'>
      </div>
      <div className='row title'>
        <span>
          {localTranslations.get('manage_profile_title', 'Administrar perfiles')}
        </span>
      </div>
      <div className='row avatar-option'>
        <div className='container'>{getAvatars(props.items)}</div>
      </div>
      <div className='row button'>
        <Button id={'admin-button'} order={['text']} className='button' text={localTranslations.get('manage_profiles_ok_btn', 'Listo perfiles')}
          onClick={() => props.onSetAction(constant.START)} />
      </div>
    </div>
  );
};

const getAvatars = (items) => {

  if (items && items.length) {
    return items.map((item, index) => {
      let order = item.order ? item.order : ['icon', 'text'];
      const imgSrc = Utils.adaptImageProtocol(`${item.imgSrc}${UtilsProfile.getAddAvatar() === item.imgSrc ? '' : '&impolicy=resize&vwidth=150'}` || localAssets.get('placeholder_profile', '/images/placeholder_talent_movie.png'));

      return (
        <div className='image'>
          <ImageButton order={order} className='button'
            imgSrc={imgSrc}
            text={item.name}
            iconClassName={'fa fa-pencil'}
            onClick={(e) => {
              item.clickHandler(item);
            }}
            onBlur={() => logger.debug('onBlur')}
            imgId = {`a.imgadmin${index}`}
          />
        </div>
      );
    });
  }
  else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Profile/Admin.jsx